<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListSale()" isJump />
    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      class="parent-table"
      size="mini"
      show-footer
      border="none"
      :showOverflow="false"
      :row-config="{ isCurrent: false, isHover: false }"
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 148"
      :footer-method="footerMethod"
    >
      <template #header_content>
        <div class="parent-header">
          <div class="flex flex-y-center">
            <div class="flex flex-y-center">
              <el-button type="success" size="mini" @click="itemDo()">新增核算单</el-button>

              <el-dropdown class="m-l-5">
                <el-button type="default" size="mini">
                  审核<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="itemPush()">
                    <span class="c-blue">提交</span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="$tool.hasControl(['/checkBill/leaderDoAudit'])"
                    @click.native="itemPass()"
                  >
                    <span class="c-green">通过</span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="$tool.hasControl(['/checkBill/leaderReject'])"
                    @click.native="itemReject()"
                  >
                    <span class="c-red">拒绝</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown class="m-l-5">
                <el-button type="default" size="mini">
                  开单<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="itemSk">
                    <span class="c-green">开收款单</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="itemBx">
                    <span class="c-green">关联报销</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="itemParchaseAdd()">
                    <span class="c-blue">采购申请单</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown class="m-l-5">
                <el-button type="default" size="mini">
                  打印<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="itemPrintVerify"> 核算单 </el-dropdown-item>
                  <el-dropdown-item @click.native="itemPrintQuote"> 报价单 </el-dropdown-item>
                  <el-dropdown-item @click.native="itemPrintContract"> 销售合同 </el-dropdown-item>
                  <el-dropdown-item @click.native="itemPrintOrder"> 生产订单 </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown class="m-l-5">
                <el-button type="default" size="mini">
                  操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="itemDelete">
                    <span class="c-red">删除</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="itemCopy">
                    <span class="c-green">引用新增</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <el-form class="flex flex-y-center m-l-5" @submit.native.prevent="searchListData">
              <span>销售日期：</span>
              <e-date-picker
                type="daterange"
                :value.sync="filterData.bill_date"
                @change="searchListData"
              />
              <span class="m-l-5">模糊搜索：</span>
              <el-input
                style="width: 180px"
                size="mini"
                placeholder="请输入客户名称/业务员"
                v-model="keyword"
                clearable
                @clear="searchListData"
              />
              <el-button
                class="m-l-5"
                type="primary"
                size="mini"
                icon="el-icon-search"
                @click="searchListData"
              >
                搜索
              </el-button>
            </el-form>

            <el-button-group class="m-l-5">
              <el-button
                :type="filterData.status_name === '' ? 'primary' : 'default'"
                size="mini"
                icon="el-icon-folder-opened"
                @click="filterStatus('')"
              >
                全部({{
                  totalObj.quan_bu_count ||
                  totalObj.zan_cun_count + totalObj.dai_shen_he_count + totalObj.yi_shen_he_count
                }})
              </el-button>
              <el-button
                :type="filterData.status_name === '暂存' ? 'info' : 'default'"
                size="mini"
                icon="el-icon-tickets"
                @click="filterStatus('暂存')"
              >
                暂存({{ totalObj.zan_cun_count }})
              </el-button>
              <el-button
                :type="filterData.status_name === '待审核' ? 'warning' : 'default'"
                size="mini"
                icon="el-icon-edit-outline"
                @click="filterStatus('待审核')"
              >
                待审核({{ totalObj.dai_shen_he_count }})
              </el-button>
              <el-button
                :type="filterData.status_name === '已审核' ? 'success' : 'default'"
                size="mini"
                icon="el-icon-document-checked"
                @click="filterStatus('已审核')"
              >
                已审核({{ totalObj.yi_shen_he_count }})
              </el-button>
            </el-button-group>
          </div>
        </div>
      </template>
      <template #default_content="{ row, rowIndex }">
        <div class="parent-content">
          <div class="child-header is-move">
            <div class="flex flex-y-center">
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">销售单号：</span>
                <el-link class="f-bold" type="primary" @click="itemDo(row.id)">
                  {{ row.bill_code }}
                </el-link>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">销售日期：</span>
                <span class="c-gray-deep">
                  {{ row.bill_date && row.bill_date.slice(0, 10) }}
                </span>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">客户名称：</span>
                <span class="c-gray-deep">{{ row.company_name }}</span>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">业务员：</span>
                <span class="c-gray-deep">{{ row.saler_name }}</span>
              </div>
              <div class="flex flex-y-center m-r-15">
                <el-tag v-if="row.status_name === '暂存'" size="mini" type="info"> 暂存 </el-tag>
                <el-tag v-if="row.status_name === '待审核'" size="mini" type="warning">
                  待审核
                </el-tag>
                <el-tag v-if="row.status_name === '已审核'" size="mini" type="success">
                  已审核
                </el-tag>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">订单销售金额：</span>
                <b class="c-orange">{{ row.sales_amount_total }}元</b>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">订单利润：</span>
                <b class="c-orange">{{ row.profit_total }}元</b>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">订单利润率：</span>
                <b class="c-orange">{{ row.profit_rate_total }}%</b>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">备注：</span>
                <span class="c-gray-deep">{{ row.bill_remark || '无' }}</span>
              </div>
              <div class="flex flex-y-center m-r-15">
                <el-button
                  v-if="row.status === 0"
                  type="primary"
                  size="mini"
                  plain
                  @click="itemPush(row)"
                >
                  提交审核
                </el-button>
                <el-button
                  v-if="$tool.hasControl(['/checkBill/leaderDoAudit']) && row.status === 1"
                  type="success"
                  size="mini"
                  plain
                  @click="itemPass(row)"
                >
                  通过审核
                </el-button>
                <el-button
                  v-if="$tool.hasControl(['/checkBill/leaderReject']) && row.status > 1"
                  type="danger"
                  size="mini"
                  plain
                  @click="itemReject(row)"
                >
                  拒绝审核
                </el-button>
                <el-button v-if="row.status === 2" size="mini" plain @click="itemParchaseAdd(row)">
                  开采购申请单
                </el-button>
              </div>
            </div>
          </div>
          <vxe-grid
            :ref="`refSubTable_${rowIndex}`"
            class="child-table"
            size="mini"
            show-footer
            :row-config="{ isCurrent: false, isHover: false }"
            :columns="subTableColumn"
            :data="row.tableSaleData"
            :footer-method="subFooterMethod"
          >
            <!-- slot_default -->
            <template #default_photo_list="{ row }">
              <e-upload-image v-if="row.photo_list" :list.sync="row.photo_list" disabled />
            </template>
          </vxe-grid>
        </div>
      </template>

      <template #footer_content>
        <div class="flex">
          <span class="m-r-15 m-l-5">合计</span>
          <span class="m-r-15">
            <span>订单销售金额：</span>
            <span class="f-bold c-orange">{{ totalObj.sales_amount_total_all }}元</span>
          </span>
          <span class="m-r-15">
            <span>订单利润：</span>
            <span class="f-bold c-orange">{{ totalObj.profit_total_all }}元</span>
          </span>
          <span class="m-r-15">
            <span>订单利润率：</span>
            <span class="f-bold c-orange">{{ totalObj.profit_rate_all }}%</span>
          </span>
        </div>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-开收款单 -->
    <PopupSk
      v-if="isShowPopupSk"
      :show.sync="isShowPopupSk"
      :companyName="activeCompanyName"
      :billId="activeBillId"
      @success="searchListData"
    />

    <!-- 弹窗-关联报销 -->
    <PopupBx
      v-if="isShowPopupBx"
      :show.sync="isShowPopupBx"
      :billId="activeBillId"
      @success="searchListData"
    />

    <!-- 弹窗-采购申请 -->
    <PopupApplyPurchase
      v-if="isShowPopupApplyPurchase"
      :show.sync="isShowPopupApplyPurchase"
      :billId="activeBillId"
      @success="searchListData"
    />
  </div>
</template>

<script>
import PopupSk from '../../../common/popup-sk'
import PopupBx from '../../../common/popup-bx'
import PopupApplyPurchase from '../../order/list/popup-apply-purchase'
export default {
  components: {
    PopupSk,
    PopupBx,
    PopupApplyPurchase
  },
  data() {
    return {
      loading: true,
      keyword: '',

      // filter
      filterData: {
        bill_date: [this.$util.getDate().monthDay, this.$util.getDate().today],
        status_name: ''
      },
      sortData: {
        bill_id: 'desc'
      },

      // table
      tableData: [],
      tableColumn: [
        {
          type: 'radio',
          width: '0px'
        },
        {
          title: '表格头部内容',
          slots: { header: 'header_content', default: 'default_content', footer: 'footer_content' }
        }
      ],
      subTableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '产品图片',
          field: 'photo_list',

          width: 63,
          slots: { default: 'default_photo_list' }
        },
        {
          title: '品名',
          field: 'craft',

          width: 200
        },
        {
          title: '规格',
          field: 'sales_specification',

          width: 200
        },
        {
          title: '单位',
          field: 'unit',

          width: 120
        },
        {
          title: '数量',
          field: 'counts',

          width: 120
        },
        {
          title: '单价(元)',
          field: 'sales_price',

          width: 120
        },
        {
          title: '金额(元)',
          field: 'sales_amount',

          width: 120
        },
        {
          title: '',
          field: ''
        }
      ],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        zan_cun_count: '',
        dai_shen_he_count: '',
        yi_shen_he_count: '',
        sales_amount_total_all: '',
        profit_total_all: '',
        profit_rate_all: ''
      },
      activeCompanyName: '',
      activeBillId: null,
      isShowPopupSk: false,
      isShowPopupBx: false,
      isShowPopupApplyPurchase: false
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    statusList() {
      let result = [
        {
          key: `全部`,
          val: ''
        },
        {
          key: `暂存(${this.totalObj.zan_cun_count})`,
          val: '暂存'
        },
        {
          key: `待审核(${this.totalObj.dai_shen_he_count})`,
          val: '待审核'
        },
        {
          key: `已审核(${this.totalObj.yi_shen_he_count})`,
          val: '已审核'
        }
      ]
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // 筛选状态
    filterStatus(val) {
      this.filterData.status_name = val
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/checkBill/list',
        data: {
          keyword: this.keyword,
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          filterData: this.filterData,
          sortData: this.sortData
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = data.list
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
            this.totalObj.zan_cun_count = res.data.zan_cun_count
            this.totalObj.dai_shen_he_count = res.data.dai_shen_he_count
            this.totalObj.yi_shen_he_count = res.data.yi_shen_he_count
            this.totalObj.sales_amount_total_all = res.data.sales_amount_total_all
            this.totalObj.profit_total_all = res.data.profit_total_all
            this.totalObj.profit_rate_all = res.data.profit_rate_all
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) return '合计'
        })
      ]
    },
    // 子表格底部
    subFooterMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'sales_amount'].includes(column.field)) {
            return this.$util.listFieldTotal(data, column.field)
          }
        })
      ]
    },
    // 获取-当前单选行
    getRadioRecord() {
      return this.$refs.refTable.getRadioRecord()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setRadioRow(params.row) // 选中radio
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowRadio = this.$refs.refTable.isCheckedByRadioRow(row)
        if (isCurrentRowRadio) {
          this.$refs.refTable.clearRadioRow() // 清空radio
        } else {
          this.$refs.refTable.setRadioRow(row) // 选中radio
        }
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 项-引用新增
    itemCopy() {
      let row = this.getRadioRecord()
      if (row) {
        this.itemCopyAction(row.id)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-引用新增
    itemCopyAction(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/copy',
        params: {
          id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('引用新增成功')
            this.getListData()
          }
        })
        .catch(() => {})
    },
    // 项-增改
    itemDo(id) {
      let url = '/sale/verify/detail'
      if (id) url = `${url}?id=${id}`
      window.open(url, '_blank')
    },
    // 项-打印-核算单
    itemPrintVerify() {
      let row = this.getRadioRecord()
      if (row) {
        this.itemPrintVerifyAction(row.bill_id)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-打印-核算单-执行
    itemPrintVerifyAction(id) {
      window.open(`/sale/verify/print?id=${id}`, '_blank')
    },
    // 项-删除
    itemDelete() {
      let row = this.getRadioRecord()
      if (row) {
        this.itemDeleteAction(row)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-删除-执行
    itemDeleteAction(row) {
      this.$confirm(`销售单号：${row.bill_code}，是否删除该核算单?`, '提示')
        .then(() => {
          this.itemDeleteConfirm(row.id)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    itemDeleteConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/doDelete',
        params: {
          id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success(res.data.msg)
            this.getListData()
          }
        })
        .catch(() => {})
    },
    // 项-提交审核
    itemPush(itemRow) {
      let row = itemRow || this.getRadioRecord()
      if (row) {
        if (row.status !== 0) {
          this.$message.error('暂存状态的单据才能提交审核')
          return
        }
        this.itemPushConfirm(row.bill_id)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-提交审核-确认
    itemPushConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/salerDoAudit',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已提交审核')
          this.getListData()
        }
      })
    },
    // 项-审核拒绝
    itemReject(itemRow) {
      let row = itemRow || this.getRadioRecord()
      if (row) {
        if (row.status === 0) {
          this.$message.error('暂存状态的单据不能审核拒绝')
          return
        }
        this.itemRejectAction(row)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-审核拒绝
    itemRejectAction(row) {
      this.$confirm(`销售单号：${row.bill_code}，该核算单是否驳回审核?`, '提示')
        .then(() => {
          this.itemRejectConfirm(row.bill_id)
        })
        .catch(() => {})
    },
    // 项-审核拒绝-确认
    itemRejectConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/leaderReject',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已驳回审核')
          this.getListData()
        }
      })
    },
    // 项-审核通过
    itemPass(itemRow) {
      let row = itemRow || this.getRadioRecord()
      if (row) {
        if (row.status !== 1) {
          this.$message.error('待审核状态的单据才能审核通过')
          return
        }
        this.itemPassAction(row)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-审核通过
    itemPassAction(row) {
      this.$confirm(`销售单号：${row.bill_code}，该核算单是否通过审核?`, '提示')
        .then(() => {
          this.itemPassConfirm(row.bill_id)
        })
        .catch(() => {})
    },
    // 项-审核通过-确认
    itemPassConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/leaderDoAudit',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已通过审核')
          this.getListData()
        }
      })
    },
    // 项-打印-报价单
    itemPrintQuote() {
      let row = this.getRadioRecord()
      if (row) {
        window.open(`/sale/quote/print?id=${row.bill_id}`, '_blank')
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-打印-销售合同
    itemPrintContract() {
      let row = this.getRadioRecord()
      if (row) {
        window.open(`/sale/contract/print?id=${row.bill_id}`, '_blank')
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-打印-生产订单
    itemPrintOrder() {
      let row = this.getRadioRecord()
      if (row) {
        window.open(`/sale/order/print?id=${row.bill_id}`, '_blank')
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-开收款单
    itemSk() {
      let row = this.getRadioRecord()
      if (row) {
        this.activeCompanyName = row.company_name
        this.activeBillId = row.bill_id
        this.isShowPopupSk = true
      } else {
        this.activeBillId = null
        this.itemChoosePrompt()
      }
    },
    // 项-关联报销
    itemBx() {
      let row = this.getRadioRecord()
      if (row) {
        this.activeBillId = row.bill_id
        this.isShowPopupBx = true
      } else {
        this.activeBillId = null
        this.itemChoosePrompt()
      }
    },
    // 项-生成采购申请单
    itemParchaseAdd(itemRow) {
      let row = itemRow || this.getRadioRecord()
      if (row) {
        if (row.status !== 2) {
          this.$message.error('已审核状态的单据才能生成采购申请单')
          return
        }
        this.activeBillId = row.bill_id
        this.isShowPopupApplyPurchase = true
      } else {
        this.activeBillId = null
        this.itemChoosePrompt()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
